import generateAndDownloadExcelFile from '../../../../../../component/excel/generate-and-download-excel-file';
import {
  WorkingHoursEntity2,
  WorkingHoursResponse,
  WorkingHoursStatus,
} from '../../../../../../api/types/lecturers/working-hours/working-hours.type';
import dateFormat from '../../../../../../utils/date-format';
import { formatLecturerHourUnits } from '../../../../../../utils/lecturer-hour-units';

const getWorkingHoursStatusText = (status: WorkingHoursStatus): string => {
  switch (status) {
    case WorkingHoursStatus.PendingForApproval:
      return 'ממתין לאישור';
    case WorkingHoursStatus.Approved:
      return 'מאושר';
    case WorkingHoursStatus.Suspended:
      return 'מושעה';
    case WorkingHoursStatus.Reject:
      return 'נדחה';
    default:
      return status;
  }
};

const getDisplayValue = (value?: string | null, fallback = '-') =>
  value?.trim() ? value : fallback;

export const exportWorkingHoursToExcel = (
  data: WorkingHoursResponse[],
  getLatestRow: (rowData: WorkingHoursResponse) => WorkingHoursEntity2,
): void => {
  const headers = [
    'תאריך התחלה',
    'שעת התחלה',
    'שעת סיום',
    'סטטוס',
    'סוג פעילות',
    'שלוחה',
    'קורס',
    'שם קורס נוסף',
    'תוכנית',
    'שם תוכנית נוסף',
    'הערות',
    'סוג',
    'תעריף',
    'סה״כ',
  ];

  const dataRows = data.map((rowData) => {
    const latest = getLatestRow(rowData);

    return [
      dateFormat.displayFormatDate(latest.startAt),
      dateFormat.formatTimeFromDate(latest.startAt),
      dateFormat.formatTimeFromDate(latest.endAt),
      getWorkingHoursStatusText(latest.status),
      latest.activityTypeName || '-',
      getDisplayValue(latest.branchName, 'לא צוין'),
      getDisplayValue(latest.courseName),
      getDisplayValue(latest.additionalCourseName),
      getDisplayValue(latest.programName),
      getDisplayValue(latest.additionalProgramName),
      latest.notes?.trim() ? latest.notes : '-',
      latest.isManual ? 'ידני' : 'אוטומטי',
      latest.branchLecturersRates,
      formatLecturerHourUnits(latest.startAt, latest.endAt, latest.displayType),
    ];
  });

  const currentDate = new Date()
    .toLocaleDateString('he-IL')
    .replace(/\//g, '-');
  const fileName = `שעות_עבודה_${currentDate}`;

  generateAndDownloadExcelFile([headers, ...dataRows], {
    fileName,
    sheetName: 'שעות עבודה',
  });
};
